module.exports = __webpack_public_path__ + "static/img/4.64a8ebe.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/VascularSystem/Meeting711/images/4.png
// module id = 6UWl
// module chunks = 4